import { DatasetVersion, LabelingType } from './dataset'

export type MLModel = {
  id: string
  dataset_version: DatasetVersion | null
  name: string
  ml_model_files: string[]
  status: MLModelStatus | null // library models have no status
  status_display: string | null
  is_master_model: boolean
  is_active: boolean
  network_type: NetworkType | null
  brand_name: BrandName | null
  brand_name_display: string | null
  brand_logo: string | null
  model_code: string
  model_type: MLModelType
  model_type_display: string
  labeling_type: LabelingType
  labeling_type_display: string
  can_be_trained: boolean
  can_be_deployed: boolean
  can_be_tested: boolean
  deployments: string[]
  base_model: MLModel | null
  root_model: MLModel | null
  training: string | null
  is_beta: boolean
  created_by: string
  created_at: string
  updated_at: string
}

export enum MLModelStatus {
  Draft = 1,
  PreTrained = 2,
  Trained = 3,
  Evaluated = 4,
  Deployed = 5
}

export enum NetworkType {
  TAO = 1,
  CNN = 2
}

enum BrandName {
  NVIDIA_TAO = 1,
  visionplatform = 2
}

export enum MLModelType {
  Primary = 1,
  Secondary = 2
}
